import Highlight from './Highlight';

// export types
export type { HighlightProps } from './Highlight';

// export components
export { Highlight };
export default Highlight;
